<!-- 查看统计里标签成本关联的标签 -->
<template>
    <div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                max-height="470px"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column fixed show-overflow-tooltip width="180" prop="LabelCode" label="标签编码"></el-table-column>
                <el-table-column show-overflow-tooltip width="150" prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="160" prop="GoodName" label="配件名称"></el-table-column>
                <el-table-column show-overflow-tooltip width="70" prop="PackingSpec" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="CostPrice" label="标签成本"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" label="标签总成本">
                    <template slot-scope="scope">
                        {{ (scope.row.PackingSpec * scope.row.CostPrice).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="120" prop="WarehouseName" label="出仓仓库"></el-table-column>
                <el-table-column show-overflow-tooltip width="120" prop="ShelfSpaces" label="仓位"></el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="Oper" label="操作人"></el-table-column>
            </el-table>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.Page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.Limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: { GoodsId: String,WarhouseId: String },
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                Page:1,
                Limit:10,
            },
            tableDataLength:0,
            tableData: []
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/GetLabelCostStatLabelList',
                    data: {
                        GoodsId : this.GoodsId, 
                        WarhouseId : this.WarhouseId,
                        Page : this.searchData.Page,
                        Limit : this.searchData.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        updateTableData(id,stoId) {
            this.searchData.Page = 1;
            this.GoodsId = id;
            this.WarhouseId = stoId;
            this.getTableData();
        },
    }
};
</script>
<style lang="less" scoped>
.search-ctn-left {
    margin-bottom: 10px;

    .search-name {
        margin-bottom: 0;
    }
}
.pagination-ctn{
    position:static;
    bottom: auto;
    left: auto;
    width: 1000px;
    padding-left: 0px;
}
</style>
